import AuthorizedCreditCreditLimit from '@/generated/controls/authorizedCredit/AuthorizedCreditCreditLimit.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: AuthorizedCreditCreditLimit
})
